import React from "react";
import I1 from "../components/Images/image 3.svg";
import I2 from "../components/Images/image 4.svg";
import I3 from "../components/Images/image 7.svg";
const Sponsors = () => {
  const sponsorsData = [
    {
      imgSrc: I1,
      subtitle: "THE SUBTITLE",
      title: "Shooting Stars",
      description:
        "Photo booth fam kinfolk cold-pressed sriracha leggings jianbing microdosing tousled waistcoat.",
    },
    {
      imgSrc: I2,
      subtitle: "THE SUBTITLE",
      title: "The Catalyzer",
      description:
        "Photo booth fam kinfolk cold-pressed sriracha leggings jianbing microdosing tousled waistcoat.",
    },
    {
      imgSrc:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT8PIJAGwTEs8obL-EtY6eleeILXuv5JXiW7Q&s",
      subtitle: "THE SUBTITLE",
      title: "Alper Kamu",
      description:
        "Photo booth fam kinfolk cold-pressed sriracha leggings jianbing microdosing tousled waistcoat.",
    },
    {
      imgSrc: "https://www.budhanibros.com/images/logo_year.png",
      subtitle: "THE SUBTITLE",
      title: "Alper Kamu",
      description:
        "Photo booth fam kinfolk cold-pressed sriracha leggings jianbing microdosing tousled waistcoat.",
    },
    {
      imgSrc: I3,
      subtitle: "THE SUBTITLE",
      title: "Alper Kamu",
      description:
        "Photo booth fam kinfolk cold-pressed sriracha leggings jianbing microdosing tousled waistcoat.",
    },
  ];

  return (
    <section className="text-gray-600 body-font">
      <div className="container px-5 py-24 mx-auto">
        <div className=" sponsorsHeading flex flex-col text-center w-full mb-20 ">
          <h1
            className="sm:text-6xl text-5xl font-medium title-font mb-4 text-white mt-12 pt-20"
            style={{
              color: "white",
              height: "150px",
              marginTop: "20px",
              paddingTop: "50px",
              fontWeight: "bolder",
              fontSize: "xxx-large",
              background: "linear-gradient(to right, #57d7fd, #2903ff)",
              backgroundSize: "100%",
              backgroundRepeat: "no-repeat",
              backgroundPositionX: "center",
              backgroundClip: "text",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              backgroundPosition: "auto",
              textShadow: `0 0 30px #1a1b1d26,
                  0 0 50px rgba(73, 79, 94, 0.352),
                  0 0 70px rgba(114, 114, 246, 0.308),
                  0 0 100px rgba(149, 149, 243, 0.303),
                  0 0 200px rgba(149, 149, 243, 0.33),
                  0 0 300px rgba(149, 149, 243, 0.281)`,
            }}
          >
            OUR SPONSORS
          </h1>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-4">
          {sponsorsData.slice(0, 2).map((sponsor, index) => (
            <div
              key={index}
              className="relative group overflow-hidden rounded-lg"
            >
              <div className="relative w-full pb-[56.25%]">
                <img
                  alt="gallery"
                  className="absolute inset-0 w-full h-full object-contain object-center rounded-lg"
                  src={sponsor.imgSrc}
                />
                <div className="absolute inset-0 bg-black bg-opacity-50 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-center items-center p-4 text-white">
                  <h2 className="tracking-widest text-sm title-font font-medium text-indigo-300 mb-1">
                    {sponsor.subtitle}
                  </h2>
                  <h1 className="title-font text-lg font-medium text-gray-100 mb-3">
                    {sponsor.title}
                  </h1>
                  <p className="leading-relaxed text-center">
                    {sponsor.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2 mt-4">
          {sponsorsData.slice(2).map((sponsor, index) => (
            <div
              key={index}
              className="relative group overflow-hidden rounded-lg"
            >
              <div className="relative w-full pb-[56.25%]">
                <img
                  alt="gallery"
                  className="absolute inset-0 w-full h-full object-contain object-center rounded-lg"
                  src={sponsor.imgSrc}
                />
                <div className="absolute inset-0 bg-black bg-opacity-50 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-center items-center p-4 text-white">
                  <h2 className="tracking-widest text-sm title-font font-medium text-indigo-300 mb-1">
                    {sponsor.subtitle}
                  </h2>
                  <h1 className="title-font text-lg font-medium text-gray-100 mb-3">
                    {sponsor.title}
                  </h1>
                  <p className="leading-relaxed text-center">
                    {sponsor.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Sponsors;
